import { useEffect, useState } from "react";
import { BRAND } from "@/lib/brand";

// Renders a click-to-call link on mobile/touch devices, and plain text on
// desktop (so desktop users are not prompted to open a dialer app).
export function PhoneLink({ className = "", children }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px), (pointer: coarse)");
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  if (isMobile) {
    return (
      <a href={BRAND.phoneHref} data-testid="phone-call-link" className={className}>
        {children}
      </a>
    );
  }
  return (
    <span data-testid="phone-text" className={className}>
      {children}
    </span>
  );
}
